import { Text } from "@chakra-ui/react";
import { PropTypes } from "prop-types";

const LoadingTitle = ({ sortedFinalResults, resultCardLookup }) => {
  const suitableFinanceTypes = sortedFinalResults.reduce((acc, item) => {
    if (item.score > 0.75) {
      return [...acc, item];
    }
    return [...acc];
  }, []);

  if (suitableFinanceTypes.length === 4) {
    return "Based on your previous answers, any of the finance types we offer would be suitable for you.";
  }

  if (suitableFinanceTypes.length === 3) {
    return (
      <>
        Based on your previous answers —{" "}
        <Text as="span" color="#2969B0">
          {resultCardLookup[suitableFinanceTypes[0].financeType].heading}
        </Text>
        {", "}
        <Text as="span" color="#2969B0">
          {resultCardLookup[suitableFinanceTypes[1].financeType].heading}
        </Text>
        {", "}
        and{" "}
        <Text as="span" color="#2969B0">
          {resultCardLookup[suitableFinanceTypes[2].financeType].heading}
        </Text>{" "}
        are the most suitable finance types for you.
      </>
    );
  }

  if (suitableFinanceTypes.length === 2) {
    return (
      <>
        Based on your previous answers —{" "}
        <Text as="span" color="#2969B0">
          {resultCardLookup[suitableFinanceTypes[0].financeType].heading}
        </Text>{" "}
        and{" "}
        <Text as="span" color="#2969B0">
          {resultCardLookup[suitableFinanceTypes[1].financeType].heading}
        </Text>{" "}
        are the more suitable finance types for you.
      </>
    );
  }
  if (suitableFinanceTypes.length === 1) {
    return (
      <>
        Based on your previous answers,{" "}
        <Text as="span" color="#2969B0">
          {resultCardLookup[suitableFinanceTypes[0].financeType].heading}
        </Text>{" "}
        is the more suitable finance type for you.
      </>
    );
  }
};

LoadingTitle.propTypes = {
  sortedFinalResults: PropTypes.array.isRequired,
  resultCardLookup: PropTypes.object.isRequired
};

export default LoadingTitle;
